import type { TrailerFilters } from '@models/trailer'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const trailersKeys = {
  root: (companyId: number) => ['companies', companyId, 'trailers'] as const,
  trailer: (companyId: number, id: number) =>
    [...trailersKeys.root(companyId), id] as const,
  list: (filters: TrailerFilters) =>
    [
      ...trailersKeys.root(filters.companyId),
      omit(filters, ['companyId', 'page', 'limit']),
      { page: filters.page, limit: filters.limit },
    ] as const,
}

export const trailersUrls = {
  root: (companyId: number) => keyToUrl(trailersKeys.root(companyId)),
  trailer: (companyId: number, id: number) =>
    keyToUrl(trailersKeys.trailer(companyId, id)),
}
